import React from 'react';
import { Pricing } from '../components/Pricing';
import { FAQSection } from '../components/FAQ';
import { CallToAction } from '../components/CallToAction';

export const PricingPage: React.FC = () => {
  return (
    <div className="pt-20">
      <div className="bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold mb-4">Choose Your Plan</h1>
            <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
              Flexible pricing options to match your trading volume and needs. Start free and upgrade as you grow.
            </p>
          </div>
        </div>
      </div>
      
      <Pricing />
      <FAQSection />
      <CallToAction />
    </div>
  );
};